import React from "react"
import styled from "styled-components"
import { Section, SectionTitle, SpanDivider } from "../UtilComponents"
import InfoBanner from "../InfoBanner"

interface AboutSectionProps {
  className?: string
  sectionData?: {}
  lang: string
}

const AboutSection: React.FC<AboutSectionProps> = ({className, sectionData, lang}) => {
  return <Section className={className}>
          <SectionTitle>
            Imagine <SpanDivider> | </SpanDivider> Explore <SpanDivider> | </SpanDivider> Define
        </SectionTitle>
        <InfoBanner linkUrl="/about_us">
          <span className="logo-font">Casa Italia</span> is a private sourcing partner for architects, interior designers, and developers who want access to the finest of Italian and European high-end design, along with the people who know it best.
        </InfoBanner>
    </Section>
}

export default styled(AboutSection)`
  ${SectionTitle}, ${SpanDivider} {
    color:black;
  }
`
